
import { getToken, setToken, removeToken } from '@/utils/auth'
const state = {
  userInfo: {},
  token: '' || localStorage.getItem('token')
}


const mutations = {
  userInfoMut: (state, log) => {
    state.userInfo = log
  },
  SET_TOKEN: (state, user_token) => {
    state.token = user_token
  },
  SET_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  }
}

const actions = {
    setUserToken({ commit}, user_token){
      localStorage.removeItem('token')
      localStorage.setItem('token', user_token)
      setToken(user_token)
      commit('SET_TOKEN',user_token)
    },
  setUserInfo({ commit}, userInfo){
    commit('SET_INFO',userInfo)
  }
  // checkout ({ commit, state }, products) {

  //   commit('setCheckoutStatus', null)
  //   // empty cart
  //   commit('setCartItems', { items: [] })
  //   shop.buyProducts(
  //     products,
  //     () => commit('setCheckoutStatus', 'successful'),
  //     () => {
  //       commit('setCheckoutStatus', 'failed')
  //       // rollback to the cart saved before sending the request
  //       commit('setCartItems', { items: savedCartItems })
  //     }
  //   )
  // },


}
// getters
const getters = {
  userInfo:state => state.userInfo,
  _token: state => state.token
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

